// test112
(112 && 0);
